<script lang="ts">
    import { analyticsTrack } from "$lib/analytics";
    import type { AnalyticsProperties } from "../../types";
    import CTA from "./CTA.svelte";
    export let total : number

</script>

<div class="overflow-cta-block">
    <h3>{total} job-seeking candidates are actively looking, get started to talk to them.</h3>
    <p>Sign up to browse 1000+ skilled developers ready to interview on the OfferZen marketplace.</p>
    <div class="overflow-cta-block__cta">
        <CTA text="Get access to developers" url="https://www.offerzen.com/hire/get-started?marketplace_preview_lead=true" properties={{
            action: 'clicked get access',
            label: 'organic demand role pages',
            source_detail: 'candidate preview section',
            source: 'demand marketing page',
            category: 'marketing pages',
            name: 'Demand activity'
        }}/>
        <CTA text="Book a demo" url="https://www.offerzen.com/hire/book-call?marketplace_preview_lead=true" theme="outlined-blue" properties={{
            action: 'clicked book a demo',
            label: 'organic demand role pages',
            source_detail: 'candidate preview section',
            source: 'demand marketing page',
            category: 'marketing pages',
            name: 'Demand activty'
        }}/>
    </div>
</div>

<style lang="postcss">

    @import '../../styles/_mixins.css';
    .overflow-cta-block {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-end;
        background: linear-gradient(360deg, #EEF3F6 75%, rgba(238, 243, 246, 0) 100%);
        line-height: 140%;
        position: absolute;
        width: 106%;
        bottom:-50px;
        left:-30px;
        z-index: 700;
        padding:80px 0 24px;

        @mixin screen-md {
            padding:120px 80px 0;
            text-align:center;
            left:0;
            width:100%;
        }

        @mixin screen-sm {
            width:100%;
            padding:80px 24px 0;
            text-align:left;
        }

        & h3 {
            font-weight: 700;
            font-size: 24px;
            line-height: 140%;
            color:var(--color_offerzen_navy);
            margin:0;
        }

        & p {
            font-weight: 400;
            font-size: 16px;
            margin-top: 12px;
            margin-bottom: 22px;
            color:var(--color_offerzen_navy);
        }

        & .overflow-cta-block__cta {
            display: flex;
            gap:24px;
           
            & a {
                display: flex;
                margin: auto;
                font-size: 16px;
                -webkit-box-align: center;
                align-items: center;
                width: 100%;
                min-width:200px;
                -webkit-box-pack: center;
                justify-content: center;
                border-radius: 3px;
                border: 1px solid var(--color_offerzen_cerulean_secondary);
                font-family: proxima-nova, Helvetica, Arial, sans-serif;
                color: rgb(94, 165, 238);
                line-height: 1.4;
                padding: 6px 12px;
                background: transparent;
                cursor: pointer;
                height: 45px;
                text-decoration: none;
                font-weight:600;
                transition: all .8s;


                &:hover {
                    background-color: var(--color_offerzen_cerulean);
                    color:var(--color_white);
                }

                @mixin screen-sm {
                    width:100%;
                }
            }

            & .filled {
                background-color: var(--color_offerzen_cerulean_secondary);
                color:var(--color_white);

                &:hover {
                    background-color: rgb(46, 113, 193);
                    box-shadow: rgba(19, 34, 84, 0.15) 0px 4px 4px;
                }
            }

            @mixin screen-sm {
                flex-direction:column;
                gap:24px;
                width:100%;
            }
        }
    }
</style>